const PROPERTY_TYPE = {
  complete: {
    name: 'Complete job',
    deliverableId: 3,
  },
  roof_only: {
    name: 'Roof only',
    deliverableId: 2,
  },
  wall_only: {
    // not actively used anymore
    name: 'Wall only',
    deliverableId: 1,
  },
};

export default {
  PROPERTY_TYPE,
};
